module.exports = __webpack_public_path__ + "img/NO937902352.5ad34eab.png";